function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

require('../../../dgs/dgs-api'); // eslint-disable-line helix/no-restricted-dependency


require('../../../dgs/dgs-events'); // eslint-disable-line helix/no-restricted-dependency


require('./polyfill/wdh-nodelist-foreach');
/**
 * WDH Utility API
 *
 */


var WDH = /*#__PURE__*/function () {
  function WDH() {
    _classCallCheck(this, WDH);
  }

  _createClass(WDH, null, [{
    key: "resolveTemplate",
    value: function resolveTemplate(html, options) {
      // Inspired by http://krasimirtsonev.com/blog/article/Javascript-template-engine-in-just-20-line
      var re = /{([^}]+)?}/g;
      var match;
      var output = html;

      while (match = re.exec(output)) {
        output = output.replace(match[0], options[match[1]]);
      }

      return output;
    }
  }, {
    key: "getAll",
    value: function getAll(selector, parent) {
      var target = parent || document;
      var elements = target.querySelectorAll(selector);
      return Array.prototype.slice.call(elements);
    }
  }]);

  return WDH;
}();

var onLoad = window.DGS.OnLoad.getInstance().register;
var onResize = window.DGS.Resizer.getInstance().register;
var triggerResize = window.DGS.Resizer.getInstance().execute;
var onScroll = window.DGS.Scroller.getInstance().register;
var isMobileDevice = window.DGS.UserAgent.getInstance().mobileTabletCheck;
var resolveTemplate = WDH.resolveTemplate,
    getAll = WDH.getAll;
var triggerEvent = window.DGS.Event.getInstance().trigger;
var clearEvent = window.DGS.Event.getInstance().off;
var onEvent = window.DGS.Event.getInstance().on;
export { onLoad, onScroll, onResize, triggerResize, getAll, isMobileDevice, resolveTemplate, triggerEvent, clearEvent, onEvent };